import { useContext } from 'react';

import { makeStyles } from '@mui/styles';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import LearningOutcomeIcon from '@openclassrooms/ui-web/icons/LearningOutcome';
import { ImageCdn } from '@openclassrooms/images-cdn';
import learningOutcomesIcon from '../../images/learningOutcomes.svg';
import CourseContext from '../../contexts/courseContext';
import LearningOutcomesSkeleton from './LearningOutcomesSkeleton';
import styles from './styles';

const useStyles = makeStyles(styles, {
  classNamePrefix: 'LearningOutcomes',
});

const LearningOutcomes = () => {
  const classes = useStyles();
  const { course, learningOutcomes, isLoadingLearningOutcomes } = useContext(CourseContext);

  const { categoryColor } = course;

  if (isLoadingLearningOutcomes) {
    return <LearningOutcomesSkeleton />;
  }

  return (
    <>
      {learningOutcomes && (
        <div
          className={classes.root}
          style={{
            '--color': categoryColor,
          }}
        >
          <Typography variant="h3" className={classes.title} component="h2">
            {translate('course.overview.skills.title')}
          </Typography>
          <div className={classes.content}>
            <ul className={classes.list}>
              {learningOutcomes.map((learningOutcome) => (
                <ListItem key={learningOutcome.id} classes={{ root: classes.listItemContainer }}>
                  <ListItemIcon classes={{ root: classes.iconContainer }}>
                    <LearningOutcomeIcon
                      color={categoryColor}
                      ariaLabel={translate('courses.accessibility_labels.outcome.to_validate')}
                    />
                  </ListItemIcon>
                  <ListItemText primary={learningOutcome.name} />
                </ListItem>
              ))}
            </ul>
            <ImageCdn alt="" src={learningOutcomesIcon} />
          </div>
        </div>
      )}
    </>
  );
};

export default LearningOutcomes;
